import React from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from 'proto/Community/Avatar';

import styles from './AvatarList.module.scss';

interface AvatarListProps {
    avatarList: Avatar[];
}

const AvatarList = ({ avatarList }: AvatarListProps) => {
    const { t } = useTranslation();
    return (
        <div className={styles.List}>
            {Object.entries(avatarList).map(([name, value]) => (
                <img
                    className={styles.Image}
                    key={name}
                    alt={t('TRANS-avatar')}
                    src={value.imageUrl}
                />
            ))}
        </div>
    );
};

export default AvatarList;
